var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgKey(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.28165 10.2165C6.79954 9.01403 6.74742 7.68194 7.13409 6.44544C7.52076 5.20894 8.3225 4.14387 9.40379 3.43026C10.4851 2.71665 11.7796 2.39826 13.0686 2.52893C14.3575 2.65959 15.5618 3.23128 16.4779 4.14737C17.394 5.06347 17.9657 6.26776 18.0963 7.55671C18.227 8.84565 17.9086 10.1402 17.195 11.2215C16.4814 12.3028 15.4163 13.1045 14.1798 13.4912C12.9433 13.8778 11.6112 13.8257 10.4087 13.3436L10.4087 13.3435L9.37937 14.3729H7.50318V16.2491H5.62698V18.1252H2.5V14.9983L7.28178 10.2165L7.28165 10.2165Z",
    stroke: "#444444",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.0625 7.50024C14.5803 7.50024 15 7.08051 15 6.56274C15 6.04498 14.5803 5.62524 14.0625 5.62524C13.5447 5.62524 13.125 6.04498 13.125 6.56274C13.125 7.08051 13.5447 7.50024 14.0625 7.50024Z",
    fill: "#444444"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgKey);
export default __webpack_public_path__ + "static/media/key.f5f77e11.svg";
export { ForwardRef as ReactComponent };